export default __webpack_public_path__ + "static/NotoSansJP-Light-e8b70ba5fe17a3e699bf7e8542e777d6.woff";